import { createContext } from 'react'
import type { AdminSession } from '@/lib/session'
import type { LoginRequest } from '@/types/api'

export const ADMIN_ROLE = 'ADMIN'

/** Why a session ended, so the login screen can explain itself. */
export type SignOutReason = 'expired' | 'manual' | 'forbidden'

export interface AuthContextValue {
  session: AdminSession | null
  isAuthenticated: boolean
  signIn: (credentials: LoginRequest) => Promise<void>
  signOut: (reason?: SignOutReason) => void
  signOutReason: SignOutReason | null
  clearSignOutReason: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)

/**
 * Raised when the credentials are valid but the account may not use this
 * dashboard. Kept distinct from a wrong password so the interface can say which
 * of the two happened instead of blaming the password either way.
 */
export class NotAnAdminError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'NotAnAdminError'
  }
}
